var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"signin section illustration-section-01",class:[
        _vm.hasBgColor && 'has-bg-color',
        _vm.invertColor && 'invert-color'
    ]},[_c('fragment',[_c('gratitude-section1',{attrs:{"image-fill":""}}),_c('gratitude-section2')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }